import * as React from 'react';
import { useState } from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

const GeneralAudienceArticleStyles = styled.div`
  margin-bottom: 2rem;

  .article-title {
    font-size: 1.5rem;
    display: block;
    font-weight: 700;

    a {
      text-decoration: none;
      color: var(--black);
      transition: all 0.1s ease;
    }

    a:hover {
      color: var(--pop);
    }
  }
  .article-source {
    font-style: italic;
  }
`;

const JournalArticleStyles = styled.div`
  margin-top: 2rem;

  a {
    text-decoration: none;
    color: var(--pop);
  }

  .article-source {
    font-style: italic;
  }
`;

const ButtonRowStyles = styled.div`
  margin-top: 3rem;

  @media screen and (max-width: 600px) {
    display: flex;
    justify-content: space-around;

    button {
      margin: 0;
    }
  }
`;

const ButtonStyles = styled.button`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  font-family: var(--heading-fonts);
  background-color: ${(props) => props.backgroundColor};
  color: white;
  border: none;
  padding: 1rem 2rem;
  margin-right: 30px;
`;

const GoalsRespondingStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0px;
  }
`;

const ArticleStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const LogoGridStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 100px;
  align-items: center;
  gap: 30px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const WritingPage = ({ data }) => {
  const [pubs, setPubs] = useState('general');

  const articles = data.allSanityGeneralPublication.nodes;
  const journalArticles = data.allSanityReviewedPublication.nodes;

  console.log(data.allSanityLogos.nodes);

  return (
    <>
      <Header />
      <main>
        <title>Writing Page</title>
        <h1>Writing</h1>
        <GoalsRespondingStyles>
          <div>
            <h3>Goals</h3>
            <p>
              My goal is to share the beauty and wonder of God's creation as
              revealed through science to as broad an audience as possible.
            </p>
          </div>
          <div>
            <h3>Responding</h3>
            <p>
              Recognizing all of God's creation as a gift calls us to respond
              accordingly. For to those who have been given much, much will be
              expected.
            </p>
          </div>
        </GoalsRespondingStyles>
        <ButtonRowStyles>
          <ButtonStyles
            onClick={() => setPubs('general')}
            backgroundColor={pubs === 'general' ? 'var(--pop)' : 'var(--black)'}
          >
            General Audience
          </ButtonStyles>
          <ButtonStyles
            onClick={() => setPubs('reviewed')}
            backgroundColor={
              pubs === 'reviewed' ? 'var(--pop)' : 'var(--black)'
            }
          >
            Reviewed Publications
          </ButtonStyles>
        </ButtonRowStyles>
        {pubs === 'general' && (
          <div>
            <section>
              <h2>Articles and Essays for Magazines</h2>
              <ArticleStyles>
                {articles
                  .filter((article) => article.pubType === 'Magazine Article')
                  .map((article) => {
                    return (
                      <GeneralAudienceArticleStyles key={article.id}>
                        <span className="article-title">
                          <a href={article.url}>{article.title}</a>
                        </span>
                        <span className="article-source">
                          {article.source}.{' '}
                        </span>
                        <span className="article-date">{article.pubDate}</span>
                      </GeneralAudienceArticleStyles>
                    );
                  })}
              </ArticleStyles>
            </section>
            <section>
              <h2>Articles and Essays for Edited Blogs</h2>
              <ArticleStyles>
                {articles
                  .filter((article) => article.pubType === 'Edited Blog')
                  .map((article) => {
                    return (
                      <GeneralAudienceArticleStyles key={article.id}>
                        <span className="article-title">
                          <a href={article.url}>{article.title}</a>
                        </span>
                        <span className="article-source">
                          {article.source}.{' '}
                        </span>
                        <span className="article-date">{article.pubDate}</span>
                      </GeneralAudienceArticleStyles>
                    );
                  })}
              </ArticleStyles>
            </section>
          </div>
        )}
        {pubs === 'reviewed' && (
          <section>
            {journalArticles.map((article) => {
              return (
                <JournalArticleStyles key={article.id}>
                  <span>{article.authors} </span>
                  <span>
                    <a href={article.url}>{article.title}</a>{' '}
                  </span>
                  <span className="article-source">{article.source}</span>
                  <span> {article.ref}</span>
                  <span>. {article.pubDate}</span>
                </JournalArticleStyles>
              );
            })}
          </section>
        )}
        <section>
          <h2>Journals and Pages</h2>
          <LogoGridStyles>
            {data.allSanityLogos.nodes.map((logo) => {
              return (
                <a href={logo.siteUrl}>
                  <GatsbyImage
                    image={logo.siteLogo.asset.gatsbyImageData}
                    alt={logo.siteName}
                  />
                </a>
              );
            })}
          </LogoGridStyles>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default WritingPage;

export const query = graphql`
  {
    allSanityGeneralPublication(sort: { fields: pubDate, order: DESC }) {
      nodes {
        id
        url
        title
        source
        pubType
        pubDate(formatString: "MMMM YYYY")
      }
    }
    allSanityReviewedPublication(sort: { fields: pubDate, order: DESC }) {
      nodes {
        id
        url
        title
        source
        ref
        pubDate(formatString: "YYYY MMMM DD")
        authors
      }
    }
    allSanityLogos {
      nodes {
        siteName
        siteUrl
        siteLogo {
          asset {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
